<span *ngIf="breadcrumbs$ | async as breadcrumbs">
  <ul class="breadcrumb" *ngIf="breadcrumbs.length > 1">
    <li *ngFor="let breadcrumb of breadcrumbs; last as isLast">
      <a *ngIf="!isLast" [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
      <span *ngIf="isLast">{{ breadcrumb.label }}</span>
    </li>
  </ul>
</span>
